<!-- eslint-disable max-len -->
<template>
  <div v-if="value" class="base-overlay">
    <div class="base-popup rounded-md">
      <div class="welcome-modal" v-show="value">
        <div class="welcome-modal__header">
          <img class="welcome-modal__header-image" src="@/assets/images/welcome/pana-welcome.svg" alt="Welcome" />
          <button class="welcome-modal__header-close" @click.prevent="close">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 13.4L7.09999 18.3C6.91665 18.4833 6.68332 18.575 6.39999 18.575C6.11665 18.575 5.88332 18.4833 5.69999 18.3C5.51665 18.1167 5.42499 17.8833 5.42499 17.6C5.42499 17.3167 5.51665 17.0833 5.69999 16.9L10.6 12L5.69999 7.1C5.51665 6.91667 5.42499 6.68334 5.42499 6.4C5.42499 6.11667 5.51665 5.88334 5.69999 5.7C5.88332 5.51667 6.11665 5.425 6.39999 5.425C6.68332 5.425 6.91665 5.51667 7.09999 5.7L12 10.6L16.9 5.7C17.0833 5.51667 17.3167 5.425 17.6 5.425C17.8833 5.425 18.1167 5.51667 18.3 5.7C18.4833 5.88334 18.575 6.11667 18.575 6.4C18.575 6.68334 18.4833 6.91667 18.3 7.1L13.4 12L18.3 16.9C18.4833 17.0833 18.575 17.3167 18.575 17.6C18.575 17.8833 18.4833 18.1167 18.3 18.3C18.1167 18.4833 17.8833 18.575 17.6 18.575C17.3167 18.575 17.0833 18.4833 16.9 18.3L12 13.4Z"
                fill="#111724" />
            </svg>
          </button>
        </div>
        <div class="welcome-modal__body">
          <h2 class="welcome-modal__body-title">
            Witamy w Early Stage Online!
          </h2>
          <p class="welcome-modal__body-description">
            Zapraszamy na wycieczkę po naszym e-dzienniku dla rodziców i uczniów. Znajdziesz tu oceny, obecności oraz
            prace domowe zadane Twojemu dziecku na naszym kursie. W przypadku nieobecności ucznia na zajęciach łatwo
            sprawdzisz jaki był temat lekcji. Early Stage Online podaje też informacje o miejscu i czasie zajęć oraz
            pozwala na przesłanie lektorom plików z pracą domową.
          </p>
          <button class="welcome-modal__body-cta" @click.prevent="close">Rozpocznij</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WelcomeModal',
  props: {
    value: {
      required: true,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
      },
    },
  },
  methods: {
    ...mapActions('onboarding', ['setOnboardingProperty']),
    close() {
      this.setOnboardingProperty({ deviceType: 'desktop', property: 'welcomeModal', value: true });
      this.$emit('input', !this.value);
    },
  },
};
</script>


<style lang="scss" scoped>
.base-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fade 0.5s ease-in-out both;
}
.base-popup {
  background-color: white;
  color: black;
  width: 100%;
  max-width: 670px;
  border-radius: 4px;
  max-height: 100vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.welcome-modal {
  width: 100%;

  &__header {
    width: 100%;
    background-color: #F0F9FE;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 24px 16px;
    position: relative;
  }

  &__header-close {
    position: absolute;
    right: 24px;
    top: 24px;
    transition: 0.3s;
    min-width: 30px;
    min-height: 30px;

    &:hover {
      opacity: 0.5;
    }
  }

  &__body {
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;

    @media screen and (min-width: 768px) {
      padding: 32px 40px;
    }
  }

  &__body-title {
    color: #111724;
    text-align: center;
    font-family: "GT Walsheim Pro";
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 8px;
  }

  &__body-description {
    color: #2E384A;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 24px;
    text-align: center;
  }

  &__body-cta {
    display: flex;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background: #E10A7B;
    color: #FFF;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-weight: 500;
    transition: 0.3s;

    &:hover {
      background-color: #bd1e72;
    }
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
